// Inert blocks interaction, but wheel and touch can still scroll an inert page.
// Lock both the document and the app's nested scroll areas, then restore their
// exact styles. Programmatic tour navigation can still bring a target into view.
export function lockWalkthroughScroll(panel, root = document.getElementById('root')) {
  const nodes = [...new Set([document.documentElement,document.body,...(root?.querySelectorAll('.main-content,.app-main,[data-tl-scroll-region]') || [])])];
  const before = nodes.map(node => ({node,overflow:node.style.overflow,overscroll:node.style.overscrollBehavior}));
  const previous = document.documentElement.dataset.walkthroughOpen;
  document.documentElement.dataset.walkthroughOpen = 'true';
  nodes.forEach(node => { node.style.overflow = 'hidden'; node.style.overscrollBehavior = 'none'; });
  const block = event => {
    const copy = event.target?.closest?.('.tl-walkthrough-copy');
    if (copy && panel.contains(copy) && copy.scrollHeight > copy.clientHeight + 1) return;
    event.preventDefault(); event.stopPropagation();
  };
  document.addEventListener('wheel',block,{capture:true,passive:false});
  document.addEventListener('touchmove',block,{capture:true,passive:false});
  return () => {
    document.removeEventListener('wheel',block,true);document.removeEventListener('touchmove',block,true);
    before.forEach(({node,overflow,overscroll}) => {node.style.overflow = overflow;node.style.overscrollBehavior = overscroll;});
    if (previous === undefined) delete document.documentElement.dataset.walkthroughOpen;
    else document.documentElement.dataset.walkthroughOpen = previous;
  };
}
